function isCustomImageSrc(value) {
  if (!value?.trim()) return false;
  return (
    value.startsWith("data:") ||
    value.startsWith("blob:") ||
    value.startsWith("http://") ||
    value.startsWith("https://")
  );
}

function isLegacyPicPath(value) {
  if (!value) return false;
  return /^(?:\.\.\/)?pic\//.test(value) || /^\/pic\//.test(value);
}

export { isCustomImageSrc, isLegacyPicPath };

export const branchImagesById = {
  shomron: new URL("../../pic/karniSOM.jpg", import.meta.url).href,
  telmon: new URL("../../pic/talmon2.jpg", import.meta.url).href,
  beitel: new URL("../../pic/orders1.jpeg", import.meta.url).href,
  tapuach: new URL("../../pic/tapuach.jpg", import.meta.url).href,
  ariel: new URL("../../pic/ariel.jpg", import.meta.url).href,
  yakir: new URL("../../pic/yakir.jpg", import.meta.url).href,
};

const branchImagesByFile = {
  "karniSOM.jpg": branchImagesById.shomron,
  "talmon2.jpg": branchImagesById.telmon,
  "orders1.jpeg": branchImagesById.beitel,
  "tapuach.jpg": branchImagesById.tapuach,
  "ariel.jpg": branchImagesById.ariel,
  "yakir.jpg": branchImagesById.yakir,
  "logoround.png": new URL("../../pic/logoround.png", import.meta.url).href,
};

export const picUrlsByFile = {
  "gallery1.jpg": new URL("../../pic/gallery1.jpg", import.meta.url).href,
  "gallery2.jpg": new URL("../../pic/gallery2.jpg", import.meta.url).href,
  "gallery3.jpg": new URL("../../pic/gallery3.jpg", import.meta.url).href,
  "gallery4.jpg": new URL("../../pic/gallery4.jpg", import.meta.url).href,
  "gallery5.jpg": new URL("../../pic/gallery5.jpg", import.meta.url).href,
  "gallery6.jpg": new URL("../../pic/gallery6.jpg", import.meta.url).href,
  "gallery7.jpg": new URL("../../pic/gallery7.jpg", import.meta.url).href,
  "gallery8.jpg": new URL("../../pic/gallery8.jpg", import.meta.url).href,
  "gallery9.jpg": new URL("../../pic/gallery9.jpg", import.meta.url).href,
  "gallery10.jpg": new URL("../../pic/gallery10.jpg", import.meta.url).href,
  "gallery11.jpg": new URL("../../pic/gallery11.jpg", import.meta.url).href,
  "gallery12.jpg": new URL("../../pic/gallery12.jpg", import.meta.url).href,
  "gallery13.jpg": new URL("../../pic/gallery13.jpg", import.meta.url).href,
  "gallery14.jpg": new URL("../../pic/gallery14.jpg", import.meta.url).href,
  "gallery15.jpg": new URL("../../pic/gallery15.jpg", import.meta.url).href,
  "orders1.jpeg": branchImagesByFile["orders1.jpeg"],
  "logoround.png": branchImagesByFile["logoround.png"],
  "karniSOM.jpg": branchImagesByFile["karniSOM.jpg"],
  "talmon2.jpg": branchImagesByFile["talmon2.jpg"],
  "tapuach.jpg": branchImagesByFile["tapuach.jpg"],
  "ariel.jpg": branchImagesByFile["ariel.jpg"],
  "yakir.jpg": branchImagesByFile["yakir.jpg"],
  "branchesPic.jpg": new URL("../../pic/branchesPic.jpg", import.meta.url).href,
  "plancha.jpg": new URL("../../pic/plancha.jpg", import.meta.url).href,
};

function filenameFromPicRef(value) {
  const raw = String(value).trim();
  const withoutQuery = raw.split(/[?#]/)[0];
  const basename = withoutQuery.replace(/^.*\//, "");
  return basename.replace(/\.[a-f0-9]{6,}(?=\.(?:jpe?g|png|webp|gif)$)/i, "");
}

export function resolvePicSrc(value) {
  if (!value?.trim()) return picUrlsByFile["logoround.png"];

  if (isCustomImageSrc(value)) return value;

  if (!isLegacyPicPath(value) && /\.[a-f0-9]{6,}\.(?:jpe?g|png|webp|gif)$/i.test(value)) {
    return value;
  }

  const filename = filenameFromPicRef(value);
  if (filename && picUrlsByFile[filename]) {
    return picUrlsByFile[filename];
  }

  if (!isLegacyPicPath(value)) return value;

  return picUrlsByFile["logoround.png"];
}

export function resolveBranchImageSrc(branchId, value) {
  if (value && isCustomImageSrc(value)) return value;

  if (value && !isLegacyPicPath(value)) return value;

  if (branchId && branchImagesById[branchId]) return branchImagesById[branchId];

  if (value && isLegacyPicPath(value)) {
    const filename = value.replace(/^(\.\.\/)?(?:pic\/)?/, "").replace(/^\/pic\//, "");
    if (branchImagesByFile[filename]) return branchImagesByFile[filename];
  }

  return branchImagesByFile["logoround.png"];
}
